// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"cEFNNeyw7yWzVtO4WCQg","signUpButton":"rch6l7h_IhlMUF654uF5"};